const init = () => {
  const mapImage = document.querySelector('.p-map__frameInner');
  if (mapImage) {
    mapImage.scrollTop = mapImage.scrollHeight - mapImage.clientHeight;

    const pointFromLeft = mapImage.scrollWidth - 390;
    const targetScrollLeft = Math.round(pointFromLeft - mapImage.clientWidth / 2);
    const maxScrollLeft = mapImage.scrollWidth - mapImage.clientWidth;
    mapImage.scrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
  }
};

export {
    init,
};
